import { inject, Injectable } from "@angular/core";
import { OfferService } from "../../services/offer.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Router } from "@angular/router";
import { findOfferAct, loadOfferByIdAct, 
    recalculateOfferAct, recalculateSuccessOfferAct, saveOfferAct, saveSuccessOfferAct, 
    setViolationsOfferAct, showMsgErrorAct, getSignaturesOfferAct, updateOfferAct, 
    updateSuccessOfferAct, 
    sendSignaturesOfferAct,
    sendOperateSuccessOfferAct,
    sendOperateOfferAct,
    deleteSuccessOfferAct,
    deleteOfferAct,
    getSignaturesSuccessOfferAct,
    sendSignaturesSuccessOfferAct} from "./offer.actions";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class OfferEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private offerService = inject(OfferService);
    private alerta = inject(AlertaService);

    findOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findOfferAct),
            exhaustMap(action => this.offerService.findOfferById(action.id)
                .pipe(
                    map(offer => loadOfferByIdAct({ offer })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/offers']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveOfferAct),
            exhaustMap(action => this.offerService.createOffer(action.offerNew)
                .pipe(
                    map(offerNew => saveSuccessOfferAct({ offerNew })),
                    catchError(error => (error.status == 400) ? 
                        of(setViolationsOfferAct({ offerForm: action.offerNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    saveSuccessOfferEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessOfferAct),
        tap(() => {
            this.router.navigate(['/offers']);

            /*Swal.fire({
                title: "Creado nueva oferta!",
                text: "Oferta creado con exito!",
                icon: "success"
            });*/
            this.alerta.correct("Oferta creado con exito");
        })
    ), { dispatch: false });

    updateOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateOfferAct),
            exhaustMap(action => this.offerService.updateOffer(action.offerUpdated)
                .pipe(
                    map(offerUpdated => updateSuccessOfferAct({ offerUpdated })),
                    /*catchError(error => (error.status == 400) ? of(setViolationsOfferAct({ offerForm: action.offerUpdated, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )*/
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsOfferAct({ offerForm: action.offerUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessOfferEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessOfferAct),
        tap(() => {
            this.router.navigate(['/offers']);

            /*Swal.fire({
                title: "Actualizado!",
                text: "Oferta editado con exito!",
                icon: "success"
            });*/
            this.alerta.correct("Oferta editado con exito");
        })
    ), {dispatch: false});

    recalculateOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(recalculateOfferAct),
            exhaustMap(action => this.offerService.recalculateOffer(action.offerRecalculate)
                .pipe(
                    map(offerRecalculate => recalculateSuccessOfferAct({ offerRecalculate })),
                    catchError(error => (error.status == 400) ? 
                        of(setViolationsOfferAct({ offerForm: action.offerRecalculate, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    recalculateSuccessOfferEffect$ = createEffect(() => this.actions$.pipe(
        ofType(recalculateSuccessOfferAct),
        tap(() => {
            //this.router.navigate(['/offers']);
            this.alerta.correct("Oferta recalculada");
        })
    ), { dispatch: false });

    getSignaturesOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(getSignaturesOfferAct),
            exhaustMap(action => this.offerService.getSignatures(action.offerSignature)
                .pipe(
                    map(offerSignature => getSignaturesSuccessOfferAct({ offerSignature })),
                    catchError(error => (error.status == 400) ? of(setViolationsOfferAct({ offerForm: action.offerSignature, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    getSignaturesSuccessOfferEffect$ = createEffect(() => this.actions$.pipe(
        ofType(getSignaturesSuccessOfferAct),
        tap(() => {
            //this.router.navigate(['/offers']);
            this.alerta.correct("Firmas Obtenidas");
        })
    ), { dispatch: false });

    sendSignaturesOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(sendSignaturesOfferAct),
            exhaustMap(action => this.offerService.sendSignatures(action.offerSignature)
                .pipe(
                    map(offerSendSignature => sendSignaturesSuccessOfferAct({ offerSendSignature })),
                    catchError(error => (error.status == 400) ? of(setViolationsOfferAct({ offerForm: action.offerSignature, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    sendSignaturesSuccessOfferEffect$ = createEffect(() => this.actions$.pipe(
        ofType(sendSignaturesSuccessOfferAct),
        tap(() => {
            this.alerta.correct("Proceso de Firmas Iniciado");
        })
    ), { dispatch: false });

    // Operar oferta
    sendOperateOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(sendOperateOfferAct),
            exhaustMap(action => this.offerService.sendOperate(action.offerOperate)
                .pipe(
                    map(offerOperate => sendOperateSuccessOfferAct({ offerOperate })),
                    catchError(error => (error.status == 400) ? of(setViolationsOfferAct({ offerForm: action.offerOperate, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    sendOperateSuccessOfferEffect$ = createEffect(() => this.actions$.pipe(
        ofType(sendOperateSuccessOfferAct),
        tap(() => {
            this.alerta.correct("Oferta Operada Correctamente");
        })
    ), { dispatch: false });

    // Eliminar Oferta
    deleteOfferEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(deleteOfferAct),
            exhaustMap(action => this.offerService.deleteOffer(action.offerId)
                .pipe(
                    map(offerId => deleteSuccessOfferAct({ offerId })),
                    /*catchError(error => (error.status == 400) ? 
                        of(setViolationsOfferAct({ offerForm: action.offerId, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    )*/
                    catchError(error => of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    deleteSuccessOfferEffect$ = createEffect(() => this.actions$.pipe(
        ofType(deleteSuccessOfferAct),
        tap(() => {
            this.router.navigate(['/offers']);
            this.alerta.correct("Oferta Eliminada Correctamente");
        })
    ), { dispatch: false });

    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
            ofType(showMsgErrorAct),
            tap((action) => {
                this.alerta.error("Se ha precentado un error interno: ", {detail: action.error.message});
            })
        ), { dispatch: false });

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            //obj[item.field.slice(item.field.lastIndexOf('.') + 1)] = item.message;
            //obj[item.field.slice(item.field.indexOf('.') + 1).replaceAll('.', '_')] = item.message;
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };

}